<template>
  <div>
    <div class="wg-row" style="justify-content: center">
      <input
        type="button"
        class="small"
        :value="$anm22.strLang(lang, 'Print details', 'Stampa commessa')"
        @click="print('details')"
      />
      <div class="com-anm22-app-horizontal-space" style="width: 20px"></div>
      <input
        type="button"
        class="small"
        :value="
          $anm22.strLang(
            lang,
            'Print operative details',
            'Stampa operatività commessa'
          )
        "
        @click="print('opDetails')"
      />
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>

    <div id="print-div" class="only-print">
      <paglierani-print-header
        :projectId="projectId"
        :title="$anm22.strLang(lang, 'Order specs', 'Commessa')"
      ></paglierani-print-header>
      <Details :mode="'view'" :projectId="projectId" :docs="docs"></Details>
    </div>
    <div id="print-div-operative" class="only-print op-details">
      <paglierani-print-header
        :projectId="projectId"
        :title="
          $anm22.strLang(lang, 'Operative order specs', 'Operatività commessa')
        "
      ></paglierani-print-header>
      <OperativeDetails
        :mode="'view'"
        :projectId="projectId"
        :docs="docs"
      ></OperativeDetails>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: {
      type: [Number, String],
    },
    docs: {
      type: Object,
    },
  },
  data() {
    return {
      custom: "details",
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      workSelected: (state) => state.workSelected,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    work() {
      return this.$store.getters["works/get"](this.workSelected);
    },
  },
  components: {
    OperativeDetails: () =>
      import(/* webpackChunkName: "custom-965" */ "./OperativeDetails.vue"),
    Details: () => import(/* webpackChunkName: "custom-965" */ "./Details.vue"),
    PaglieraniPrintHeader: () =>
      import(
        /* webpackChunkName: "custom-965" */ "./PaglieraniPrintHeader.vue"
      ),
  },
  methods: {
    print(c) {
      let html = "";
      if (c == "details") {
        html = document.getElementById("print-div").cloneNode(true);
      } else {
        html = document.getElementById("print-div-operative").cloneNode(true);
      }

      // Get all stylesheets HTML
      const headElements = [],
        inserted = [];
      for (const node of [
        ...document.querySelectorAll('link[href$=".css"], style'),
      ]) {
        // stylesHtml += node.innerHTML;
        if (node.tagName === "STYLE") {
          const elem = document.createElement("style");
          elem.type = "text/css";
          elem.innerHTML = node.innerHTML;
          headElements.push(elem);
        } else {
          if (!inserted.find((s) => s === node.href)) {
            inserted.push(node.href);
            const elem = document.createElement("link");
            elem.type = "text/css";
            elem.rel = "stylesheet";
            elem.href = node.href;
            headElements.push(elem);
          }
        }
      }
      this.$anm22.print(html, headElements);
    },
  },
};
</script>

<style lang="scss" scoped>
.only-print {
  display: none !important;
}
@page {
  margin:1cm !important;
}
@media print {
  html,
  body {
    background-color: #fff;
    -webkit-print-color-adjust: exact;
  }
  #print-div {
    background-color: #fff;
  }
  #print-div-operative {
    background-color: #fff;
  }
  .only-print {
    display: block !important;
  }
  .print-break-after {
    break-after: page;
  }
  // .print-elem[type="text"] {
  //   // &[type="text"] {
  //     border-radius: 0;
  //     border: none;
  //     border-bottom: 1px solid #bbb;
  //   // }
  // }
}
</style>
<style lang="scss">
@media print {
  html,
  body {
    background-color: #fff;
    -webkit-print-color-adjust: exact;
  }
  input[type="text"],
  input[type="date"],
  input[type="number"],
  #print-div input[type="text"],
  #print-div input[type="date"],
  #print-div input[type="number"],
  #print-div-operative input[type="text"],
  #print-div-operative input[type="date"],
  #print-div-operative input[type="number"] {
    background-color: #fff !important;
  }
  .com-anm22-app-textarea,
  textarea #print-div .com-anm22-app-textarea,
  #print-div-operative textarea,
  #print-div textarea {
    background-color: #fff;
  }
  .com-anm22-app-select,
  select #print-div .com-anm22-app-select,
  #print-div-operative select,
  #print-div select {
    background-color: #fff;
  }
  #print-div-operative input[type="date"] {
    padding: 2px !important;
  }
}
</style>